<template>
  <aside
    :class="['aui-sidebar', `aui-sidebar--${$store.state.sidebarLayoutSkin}`]"
  >
    <div class="aui-sidebar__inner">
      <div
        class="flex justify-center items-center bg-blue-500 text-white"
        style="height: 40px;padding: 0 6px;font-size: 14px;line-height: 150%"
      >
        FZCLOUD
      </div>
      <el-menu
        :default-active="$store.state.sidebarMenuActiveName"
        :collapse="$store.state.sidebarFold"
        :unique-opened="true"
        :collapseTransition="false"
        class="aui-sidebar__menu"
      >
        <sub-menu
          v-for="menu in $store.state.sidebarMenuList"
          :key="menu.id"
          :menu="menu"
        />
      </el-menu>
    </div>
  </aside>
</template>

<script>
import SubMenu from "./main-sidebar-sub-menu";
export default {
  data() {
    return {};
  },
  components: {
    SubMenu,
  },
  created() {
    this.$store.state.sidebarMenuList = window.SITE_CONFIG["menuList"];
  },
};
</script>

<style lang="scss" scoped>
.logo-box {
  width: 100%;
  padding: 40px 20px;
  .logo-img {
    width: 80px;
    height: 80px;
    padding: 6px;
    margin: auto;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
  }
  .logo-title {
    width: 100%;
    margin-top: 16px;
    font-size: 14px;
    color: #666;
    text-align: center;
    word-spacing: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
